import Link from 'next/link'
import Image from 'next/image'
import styles from './HeaderButton.module.scss'
import { useRouter } from 'next/navigation'
import { getCustomBreakpoint } from 'utils/hooks'
import { getIconSvgPath } from 'utils'

export interface HeaderButtonProps {
  title: string
  url: string
  iconName?: 'calendar' | 'mail' | 'work'
  isTargetBlank?: boolean
  onClick: () => void
  _mockRouter?: { push: (url: string) => void }
  _mockBreakpoint?: boolean
}

const HeaderButton = ({
  title,
  url,
  iconName,
  isTargetBlank,
  onClick,
  _mockRouter,
  _mockBreakpoint
}: HeaderButtonProps) => {
  const router = _mockRouter ?? useRouter()
  const { isBreakpoint: isBelowBreakpointLg } =
    _mockBreakpoint !== undefined ? { isBreakpoint: _mockBreakpoint } : getCustomBreakpoint(1280, '<')

  const iconPath = getIconSvgPath(iconName || '')

  return (
    <Link
      className={`${styles['header-button']} ${isBelowBreakpointLg ? styles.below_break_point : ''}`}
      href={url}
      onClick={onClick}
      {...(isTargetBlank && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <Image src={iconPath} alt={`${title} icon`} width={16} height={16} />
      {!isBelowBreakpointLg && <span>{title}</span>}
    </Link>
  )
}

export default HeaderButton
